"use client";

import type * as React from "react";

import { useInView } from "@ui/lib/useInView";
import { cn } from "@ui/lib/utils";
import { useRef } from "react";

export interface BlockProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  className?: string;
  name: string;
  revealClass?: string;
  tag?: "div" | "section";
}

const Block = ({ name, tag = "div", revealClass = "block-in-view", className, ...props }: BlockProps) => {
  const Tag = tag;
  const intersectionRef = useRef<HTMLDivElement>(null);
  const inView = useInView(intersectionRef, { once: true });

  return (
    <Tag
      className={cn("block-el", `block-el-${name}`, inView ? revealClass : "", className)}
      ref={intersectionRef}
      {...props}
    />
  );
};

Block.displayName = "Block";

export { Block };
